import { useState } from "react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Share2, Copy } from "lucide-react";
import { generateScoreCard, SHARE_SITE } from "@/lib/shareCard";

export function ShareScore({ score, total, level = "", title = "Smart Buyer Quiz", testid = "share-score" }) {
  const [busy, setBusy] = useState(false);
  const lvl = level ? ` (${level} level)` : "";
  const caption = `I scored ${score}/${total} on the ${title}${lvl} at Real Estate with Ayush. Try it: ${SHARE_SITE}`;

  const share = async () => {
    setBusy(true);
    try {
      const dataUrl = await generateScoreCard({ score, total, level, title });
      const blob = await (await fetch(dataUrl)).blob();
      const file = new File([blob], "my-score.png", { type: "image/png" });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], text: caption, title: "My score" });
      } else {
        const a = document.createElement("a");
        a.href = dataUrl; a.download = "my-score.png"; a.click();
        try { await navigator.clipboard.writeText(caption); } catch (e) { /* ignore */ }
        toast.success("Score card downloaded & caption copied — post it on Instagram!");
      }
    } catch (e) {
      toast.error("Couldn't create the share card. Please try again.");
    } finally { setBusy(false); }
  };

  const copy = async () => {
    try { await navigator.clipboard.writeText(caption); toast.success("Caption + link copied!"); }
    catch (e) { toast.error("Copy failed on this browser."); }
  };

  return (
    <div className="flex flex-wrap justify-center gap-3" data-testid={testid}>
      <Button onClick={share} disabled={busy} className="rounded-none bg-cyan font-mono text-xs uppercase tracking-widest text-white hover:bg-cyan/90" data-testid={`${testid}-btn`}>
        <Share2 className="mr-2 h-4 w-4" /> {busy ? "Creating…" : "Share my score"}
      </Button>
      <Button variant="outline" onClick={copy} className="rounded-none border-border font-mono text-xs uppercase tracking-widest hover:border-foreground" data-testid={`${testid}-copy`}>
        <Copy className="mr-2 h-4 w-4" /> Copy link
      </Button>
    </div>
  );
}
